export default "__VITE_ASSET__694908ab__"